import { createSlice } from '@reduxjs/toolkit'

import { BillingReport } from 'common/api/v1/types'
import { readBilling } from '../actions/billingActions'
import { createLoadingReducer } from './shared'

interface State {
  billing?: BillingReport
  loading: boolean
  error: boolean
}
export const initialStateBilling: State = {
  billing: undefined,
  loading: false,
  error: false,
}

const { isLoadingAction, loadingReducer } = createLoadingReducer<State>(readBilling)

const billingSlice = createSlice({
  name: 'billing',
  initialState: initialStateBilling,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(readBilling.pending, (state): State => ({ ...state, error: false, billing: undefined }))
      .addCase(readBilling.fulfilled, (state, { payload: billing }): State => ({ ...state, error: false, billing }))
      .addCase(readBilling.rejected, (state): State => ({ ...state, error: true, billing: undefined }))
      .addMatcher(isLoadingAction, loadingReducer)
  },
})

export default billingSlice.reducer
